export default __webpack_public_path__ + "d35bc329cb88d974134f43556720aaab.png";